// import Section from "@/Components/LayoutComponents/Section";
import style from "./style.module.scss";
import Image from "next/image";

const Testimonial: React.FC<any> = ({ block, testimonialIndex  }) => {
  const testimonials = block?.testimonials?.data || [];

  const currentTestimonial = testimonials[testimonialIndex]?.attributes;

  if (testimonials.length === 0) {
    return null;
  }

  const { text, Rating, author, AutherPosition, reviewTitle } =
    currentTestimonial;

  return (
    <>
      {/* <Section> */}
      <div
        className={`${style.sectionWrapper} xl:py-[100px] xl:px-[107px] md:py-[80px] md:px-[83px] py-[56px] px-[24px] my-[20px]`}
      >
        <div className={style.gradientOverlay}>
          <div className={style.innerGradient} />
        </div>
        <div className={`border-border border overflow-hidden h-full`}>
          <div
            className={`border-b-0 !bg-white p-[20px_20px_12px_20px] md:p-[30px_30px_12px_30px]`}
          >
            <div className="flex md:mt-0 mt-2 mb-[12px] lx-mt w-full md:w-auto items-center gap-1">
              {Array.from({ length: Math.round(Rating) }, (_, i) => (
                <Image
                  key={i}
                  src="/images/ServicesPage/Star.svg"
                  alt="Star"
                  width={28}
                  height={28}
                  // className={i < rating ? "opacity-100" : "opacity-30"}
                />
              ))}
            </div>
            <div className={`w-fit`}>
              <div className="xl:mr-2 lg:mr-4">
                <p className="font-bold text-[20px] md:text-[24px] md:leading-[31.2px] text-primary-text  leading-[30px] line-clamp-3 text-overflow-ellipsis">
                  {reviewTitle}
                </p>
              </div>
            </div>
          </div>

          <div
            className={`bg-white p-[0px_20px_20px_20px] md:p-[0px_30px_30px_30px] `}
          >
            <p className="text-black font-semibold text-subtitle-2 line-clamp-12 text-overflow-hidden min-h-[50px]">
              {text}
            </p>
          </div>

          <div className={`bg-white`}>
            <div className={`mx-8 py-6 review_footer border-t  border-border`}>
              <div
                className={`text-right flex flex-col justify-end w-full ${style.ThemeBody}`}
              >
                <p className="font-semibold text-subtitle-1">{author}</p>
                <span className="text-subtitle-5 font-regular mt-1">
                  {AutherPosition}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </Section> */}
    </>
  );
}

export default Testimonial;
